import React from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Button} from "primereact/button";
import {Badge} from "primereact/badge";

const CandidateEducationListComponent = (props) => {

  const history = useHistory();
  const {id} = useParams();
  const educations = props.educations || [];

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {(localStorage.getItem('roles') || '').includes('role_recruitment_candidate_write') &&
          <Button icon="pi pi-pencil" className="p-button-warning p-button-sm p-mr-2"
                  onClick={() => {
                      history.push(`/recruitment/candidate/read/${id}?update=candidate-education&candidateEducationId=${rowData.id}&candidateId=${id}`)
                  }} />
        }
      </React.Fragment>
    );
  }

  const renderCard = (rowData) => (
    <div key={rowData.id} className="p-card p-shadow-none p-mb-2" style={{overflow: 'hidden'}}>
      <div className="p-p-3 p-d-flex p-jc-between p-ai-start p-flex-wrap" style={{gap: '1rem'}}>
        <div className="p-d-flex p-flex-column" style={{gap: '0.85rem', flex: '1 1 240px'}}>
          <div className="p-d-flex p-ai-center p-flex-wrap" style={{gap: '0.5rem'}}>
            <span style={{display: 'inline-block'}}>
              <Badge value={rowData?.education_level?.name || props.t('candidateEducationLevel.' + rowData?.level, {defaultValue: rowData?.level || props.t('noLevel')})} severity="info" rounded />
            </span>
            <span className="p-text-bold">{rowData?.school || props.t('noSchoolProvided')}</span>
          </div>
          <div className="p-text-600">{rowData?.master || props.t('noTrainingProvided')}</div>
          <div className="p-text-secondary">
            {props.t('graduation')}: {rowData?.end_date ? window.App.formatDateValue(rowData.end_date) : <span style={{color: '#a8a8a8'}}>? </span>}
          </div>
        </div>
        <div className="p-d-flex p-ai-start">
          {actionBodyTemplate(rowData)}
        </div>
      </div>
    </div>
  )

  return (
    <div className="p-d-flex p-flex-column">
      {educations.length > 0 ? educations.map(renderCard) : (
        <div className="p-py-2 p-text-secondary">
          {props.t('noResults')}
        </div>
      )}
    </div>
  )
}
export default withTranslation('common')(CandidateEducationListComponent);
